module.exports = __webpack_public_path__ + "img/user-default.168824d1.jpg";